// extracted by mini-css-extract-plugin
module.exports = {"PageHolder":"EditPage_PageHolder__1_WWe","Pageinfo":"EditPage_Pageinfo__2-3eC"};